import Vue from 'vue';
import VueLazyload from '../plugins/vue-lazyload';

Vue.use(VueLazyload, {
  lazyComponent: true,
  lazyImage: true,
  attempt: 1,
  throttleWait: 0,
  listenEvents: ['load', 'scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'touchmove'],
  observer: true,
  observerOptions: {
    rootMargin: '400px',
    threshold: 1
  }
});
